import { useState } from 'react';
import { animatedEmojiSrc, staticEmojiSrc } from '../lib/emoji';

/**
 * Одиночный эмодзи с непрерывной анимацией Noto. WebP-файлы содержат бесконечный повтор;
 * при ошибке загрузки показываем статичный SVG, затем исходный текстовый глиф.
 */
export default function Emoji({
  char,
  animated = false,
  className,
  showLoadingSpinner = false,
}: {
  char: string;
  animated?: boolean;
  className?: string;
  /** Кружок ожидания загрузки картинки в сетке пикера. */
  showLoadingSpinner?: boolean;
}) {
  const animSrc = animated ? animatedEmojiSrc(char) : null;
  const staticSrc = staticEmojiSrc(char);
  const [failedSources, setFailedSources] = useState<string[]>([]);
  const [loaded, setLoaded] = useState(false);
  const src = animSrc && !failedSources.includes(animSrc)
    ? animSrc
    : staticSrc && !failedSources.includes(staticSrc) ? staticSrc : null;

  if (!src) return <>{char}</>;

  const img = (
    <img
      src={src}
      alt={char}
      draggable={false}
      className={
        'emoji-img' + (className ? ' ' + className : '') +
        (showLoadingSpinner && !loaded ? ' emoji-img-hidden' : '')
      }
      // Для картинки, уже лежащей в HTTP-кэше браузера, onLoad мог успеть отработать ДО
      // того, как React повесит обработчик (грузится синхронно быстрее коммита) — тогда
      // спиннер завис бы навсегда. ref-колбэк подстраховывает: .complete уже true к моменту
      // маунта, если картинка правда из кэша.
      ref={(el) => {
        if (el?.complete) setLoaded(true);
      }}
      onLoad={() => setLoaded(true)}
      onError={() => setFailedSources((sources) => [...sources, src])}
    />
  );

  if (!showLoadingSpinner) return img;

  return (
    <span className="emoji-loading-wrap">
      {img}
      {!loaded && <span className="emoji-spinner" />}
    </span>
  );
}
